function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { observer, RecursionField, useField, useFieldSchema } from '@formily/react';
import { isArr, isBool, isFn } from '@formily/shared';
import { Badge, Pagination, Select, Space, Table } from 'antd';
import cls from 'classnames';
import React, { createContext, Fragment, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { ArrayBase } from "../ArrayBase";
import { SortableContainer, SortableElement } from "../ArrayBase/sort";
import { genArrayTableStyles } from "./style";
import { useCssInJs } from "../../hooks";
var SortableRow = SortableElement(function (props) {
  return /*#__PURE__*/React.createElement("tr", props);
});
var SortableBody = SortableContainer(function (props) {
  return /*#__PURE__*/React.createElement("tbody", props);
});
var isColumnComponent = function isColumnComponent(schema) {
  var _schema$xComponent;
  return ((_schema$xComponent = schema['x-component']) === null || _schema$xComponent === void 0 ? void 0 : _schema$xComponent.indexOf('Column')) > -1;
};
var isOperationsComponent = function isOperationsComponent(schema) {
  var _schema$xComponent2;
  return ((_schema$xComponent2 = schema['x-component']) === null || _schema$xComponent2 === void 0 ? void 0 : _schema$xComponent2.indexOf('Operations')) > -1;
};
var isAdditionComponent = function isAdditionComponent(schema) {
  var _schema$xComponent3;
  return ((_schema$xComponent3 = schema['x-component']) === null || _schema$xComponent3 === void 0 ? void 0 : _schema$xComponent3.indexOf('Addition')) > -1;
};
var useArrayTableSources = function useArrayTableSources() {
  var arrayField = useField();
  var schema = useFieldSchema();
  var parseSources = function parseSources(schema) {
    if (isColumnComponent(schema) || isOperationsComponent(schema) || isAdditionComponent(schema)) {
      var _schema$xComponentP, _schema$xComponentP2, _field$component;
      if (!((_schema$xComponentP = schema['x-component-props']) !== null && _schema$xComponentP !== void 0 && _schema$xComponentP['dataIndex']) && !schema['name']) return [];
      var name = ((_schema$xComponentP2 = schema['x-component-props']) === null || _schema$xComponentP2 === void 0 ? void 0 : _schema$xComponentP2['dataIndex']) || schema['name'];
      var field = arrayField.query(arrayField.address.concat(name)).take();
      var columnProps = (field === null || field === void 0 || (_field$component = field.component) === null || _field$component === void 0 ? void 0 : _field$component[1]) || schema['x-component-props'] || {};
      var display = (field === null || field === void 0 ? void 0 : field.display) || schema['x-display'] || 'visible';
      return [{
        name: name,
        display: display,
        field: field,
        schema: schema,
        columnProps: columnProps
      }];
    } else if (schema.properties) {
      return schema.reduceProperties(function (buf, schema) {
        return buf.concat(parseSources(schema));
      }, []);
    }
  };
  var parseArrayItems = function parseArrayItems(schema) {
    if (!schema) return [];
    var sources = [];
    var items = isArr(schema) ? schema : [schema];
    return items.reduce(function (columns, schema) {
      var item = parseSources(schema);
      if (item) {
        return columns.concat(item);
      }
      return columns;
    }, sources);
  };
  if (!schema) throw new Error('can not found schema object');
  return parseArrayItems(schema.items);
};
var useArrayTableColumns = function useArrayTableColumns(dataSource, field, sources) {
  return sources.reduce(function (buf, _ref, key) {
    var name = _ref.name,
      columnProps = _ref.columnProps,
      schema = _ref.schema,
      display = _ref.display;
    if (display !== 'visible') return buf;
    if (!isColumnComponent(schema)) return buf;
    return buf.concat(_objectSpread(_objectSpread({}, columnProps), {}, {
      key: key,
      dataIndex: name,
      render: function render(value, record) {
        var index = dataSource === null || dataSource === void 0 ? void 0 : dataSource.indexOf(record);
        var children = /*#__PURE__*/React.createElement(ArrayBase.Item, {
          index: index,
          record: function record() {
            var _field$value;
            return field === null || field === void 0 || (_field$value = field.value) === null || _field$value === void 0 ? void 0 : _field$value[index];
          }
        }, /*#__PURE__*/React.createElement(RecursionField, {
          schema: schema,
          name: index,
          onlyRenderProperties: true
        }));
        return children;
      }
    }));
  }, []);
};
var useAddition = function useAddition() {
  var schema = useFieldSchema();
  return schema.reduceProperties(function (addition, schema, key) {
    if (isAdditionComponent(schema)) {
      return /*#__PURE__*/React.createElement(RecursionField, {
        schema: schema,
        name: key
      });
    }
    return addition;
  }, null);
};
var schedulerRequest = {
  request: null
};
var StatusSelect = observer(function (props) {
  var _props$options;
  var field = useField();
  var prefixCls = 'form-array-table';
  var errors = field.errors;
  var parseIndex = function parseIndex(address) {
    var _address$slice$match;
    return Number((_address$slice$match = address.slice(address.indexOf(field.address.toString()) + 1).match(/(\d+)/)) === null || _address$slice$match === void 0 ? void 0 : _address$slice$match[1]);
  };
  var options = (_props$options = props.options) === null || _props$options === void 0 ? void 0 : _props$options.map(function (_ref2) {
    var label = _ref2.label,
      value = _ref2.value;
    var val = Number(value);
    var hasError = errors.some(function (_ref3) {
      var address = _ref3.address;
      var currentIndex = parseIndex(address);
      var startIndex = (val - 1) * props.pageSize;
      var endIndex = val * props.pageSize;
      return currentIndex >= startIndex && currentIndex <= endIndex;
    });
    return {
      label: hasError ? /*#__PURE__*/React.createElement(Badge, {
        dot: true
      }, label) : label,
      value: value
    };
  });
  var width = String(options === null || options === void 0 ? void 0 : options.length).length * 15;
  return /*#__PURE__*/React.createElement(Select, {
    value: props.value,
    onChange: props.onChange,
    options: options,
    virtual: true,
    style: {
      width: width < 60 ? 60 : width
    },
    className: cls("".concat(prefixCls, "-status-select"), {
      'has-error': errors === null || errors === void 0 ? void 0 : errors.length
    })
  });
}, {
  scheduler: function scheduler(update) {
    clearTimeout(schedulerRequest.request);
    schedulerRequest.request = setTimeout(function () {
      update();
    }, 100);
  }
});
var PaginationContext = /*#__PURE__*/createContext({});
var usePagination = function usePagination() {
  return useContext(PaginationContext);
};
var ArrayTablePagination = function ArrayTablePagination(props) {
  var _props$showPagination, _props$children;
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    current = _useState2[0],
    setCurrent = _useState2[1];
  var prefixCls = 'form-array-table';
  var showPagination = (_props$showPagination = props.showPagination) !== null && _props$showPagination !== void 0 ? _props$showPagination : true;
  var pageSize = props.pageSize || 10;
  var size = props.size || 'default';
  var dataSource = props.dataSource || [];
  var startIndex = (current - 1) * pageSize;
  var endIndex = startIndex + pageSize - 1;
  var total = (dataSource === null || dataSource === void 0 ? void 0 : dataSource.length) || 0;
  var totalPage = Math.ceil(total / pageSize);
  var pages = Array.from(new Array(totalPage)).map(function (_, index) {
    var page = index + 1;
    return {
      label: page,
      value: page
    };
  });
  var handleChange = function handleChange(current) {
    setCurrent(current);
  };
  useEffect(function () {
    if (totalPage > 0 && totalPage < current) {
      handleChange(totalPage);
    }
  }, [totalPage, current]);
  var renderPagination = function renderPagination() {
    if (totalPage <= 1 || !showPagination) return;
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-pagination")
    }, /*#__PURE__*/React.createElement(Space, null, /*#__PURE__*/React.createElement(StatusSelect, {
      value: current,
      pageSize: pageSize,
      onChange: handleChange,
      options: pages,
      notFoundContent: false
    }), /*#__PURE__*/React.createElement(Pagination, _extends({}, props, {
      pageSize: pageSize,
      current: current,
      total: dataSource.length,
      size: size,
      showSizeChanger: false,
      onChange: handleChange
    }))));
  };
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(PaginationContext.Provider, {
    value: {
      totalPage: totalPage,
      pageSize: pageSize,
      changePage: handleChange,
      showPagination: showPagination
    }
  }, (_props$children = props.children) === null || _props$children === void 0 ? void 0 : _props$children.call(props, showPagination ? dataSource === null || dataSource === void 0 ? void 0 : dataSource.slice(startIndex, endIndex + 1) : dataSource, renderPagination(), {
    startIndex: startIndex
  })));
};
var RowComp = function RowComp(props) {
  var prefixCls = 'form-array-table';
  var index = props['data-row-key'] || 0;
  return /*#__PURE__*/React.createElement(SortableRow, _extends({
    lockAxis: "y"
  }, props, {
    index: index,
    className: cls(props.className, "".concat(prefixCls, "-row-").concat(index + 1))
  }));
};

// @ts-ignore
export var ArrayTable = observer(function (props) {
  var ref = useRef();
  var field = useField();
  var prefixCls = 'form-array-table';
  var _useCssInJs = useCssInJs({
      prefix: prefixCls,
      styleFun: genArrayTableStyles,
      global: true
    }),
    wrapSSR = _useCssInJs.wrapSSR;
  var dataSource = Array.isArray(field.value) ? field.value.slice() : [];
  var sources = useArrayTableSources();
  var columns = useArrayTableColumns(dataSource, field, sources);
  var pagination = isBool(props.pagination) ? {
    showPagination: props.pagination
  } : props.pagination;
  var addition = useAddition();
  var onAdd = props.onAdd,
    onCopy = props.onCopy,
    onRemove = props.onRemove,
    onMoveDown = props.onMoveDown,
    onMoveUp = props.onMoveUp;
  var defaultRowKey = function defaultRowKey(record) {
    return dataSource.indexOf(record);
  };
  var addTdStyles = function addTdStyles(id) {
    var _ref$current;
    var node = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelector(".".concat(prefixCls, "-row-").concat(id));
    var helper = document.body.querySelector(".".concat(prefixCls, "-sort-helper"));
    if (!helper) return;
    var tds = node === null || node === void 0 ? void 0 : node.querySelectorAll('td');
    if (!tds) return;
    requestAnimationFrame(function () {
      helper.querySelectorAll('td').forEach(function (td, index) {
        if (tds[index]) {
          td.style.width = getComputedStyle(tds[index]).width;
        }
      });
    });
  };
  var getWrapperComp = useCallback(function (dataSource, start) {
    return function (props) {
      return /*#__PURE__*/React.createElement(SortableBody, _extends({}, props, {
        start: start,
        list: dataSource.slice(),
        accessibility: {
          container: ref.current || undefined
        },
        onSortStart: function onSortStart(event) {
          addTdStyles(event.active.id);
        },
        onSortEnd: function onSortEnd(_ref4) {
          var oldIndex = _ref4.oldIndex,
            newIndex = _ref4.newIndex;
          field.move(oldIndex, newIndex);
        },
        className: cls("".concat(prefixCls, "-sort-helper"), props.className)
      }));
    };
  }, [field]);
  return wrapSSR( /*#__PURE__*/React.createElement(ArrayTablePagination, _extends({}, pagination, {
    dataSource: dataSource
  }), function (dataSource, pager, _ref5) {
    var startIndex = _ref5.startIndex;
    return /*#__PURE__*/React.createElement("div", {
      ref: ref,
      className: prefixCls
    }, /*#__PURE__*/React.createElement(ArrayBase, {
      onAdd: onAdd,
      onCopy: onCopy,
      onRemove: onRemove,
      onMoveUp: onMoveUp,
      onMoveDown: onMoveDown
    }, /*#__PURE__*/React.createElement(Table, _extends({
      size: "small",
      bordered: true,
      rowKey: defaultRowKey
    }, props, {
      onChange: function onChange() {},
      pagination: false,
      columns: columns,
      dataSource: dataSource,
      components: {
        body: {
          wrapper: getWrapperComp(dataSource, startIndex),
          row: RowComp
        }
      }
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 5,
        marginBottom: 5
      }
    }, pager), sources.map(function (column, key) {
      //专门用来承接对Column的状态管理
      if (!isColumnComponent(column.schema)) return;
      return /*#__PURE__*/React.createElement(RecursionField, {
        name: column.name,
        schema: column.schema,
        onlyRenderSelf: true,
        key: key
      });
    }), addition));
  }));
});
ArrayTable.displayName = 'ArrayTable';
ArrayTable.Column = function () {
  return /*#__PURE__*/React.createElement(Fragment, null);
};
ArrayBase.mixin(ArrayTable);
var Addition = function Addition(props) {
  var array = ArrayBase.useArray();
  var _usePagination = usePagination(),
    _usePagination$totalP = _usePagination.totalPage,
    totalPage = _usePagination$totalP === void 0 ? 0 : _usePagination$totalP,
    _usePagination$pageSi = _usePagination.pageSize,
    pageSize = _usePagination$pageSi === void 0 ? 10 : _usePagination$pageSi,
    changePage = _usePagination.changePage,
    showPagination = _usePagination.showPagination;
  return /*#__PURE__*/React.createElement(ArrayBase.Addition, _extends({}, props, {
    onClick: function onClick(e) {
      var _array$field, _props$onClick;
      // 如果添加数据后将超过当前页，则自动切换到下一页
      var total = (array === null || array === void 0 || (_array$field = array.field) === null || _array$field === void 0 ? void 0 : _array$field.value.length) || 0;
      if (showPagination && total === totalPage * pageSize + 1 && isFn(changePage)) {
        changePage(totalPage + 1);
      }
      (_props$onClick = props.onClick) === null || _props$onClick === void 0 || _props$onClick.call(props, e);
    }
  }));
};
ArrayTable.Addition = Addition;
export default ArrayTable;